import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import axios from "axios";
import {handleConcursosDetailError} from "../../utils/errors";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
}));

const ApproveModal = (props) => {
    const classes = useStyles();
    const [openSpinner, setOpenSpinner] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(!open);
    };

    const handleError = (error) => {
        setOpen(false);
        setOpenSpinner(false);
        handleConcursosDetailError(error)
    }

    const handleClick = () => {
        setOpenSpinner(true);
        axios
            .post(
                window.ENV.API_URL + "/concursosRevision/" + props.concursoId + "/",
                {
                    status: "aprobado",
                }
            )
            .then(() => window.location.reload())
            .catch((error) => handleError(error));
    };

    return (
        <Fragment>
            {/*
      <Button color="primary" onClick={handleOpen}>
        {props.label}
      </Button>*/}

            <Tooltip
                onClick={handleOpen}
                title={<span className={classes.tooltip}>{props.label}</span>}
            >
                <IconButton>
                    <CheckIcon/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleOpen} scroll={"paper"} fullWidth>
                <DialogTitle>Aprobar concurso</DialogTitle>
                <DialogContent dividers={true}>
                    <div className="text-center">
                        ¿Desea aprobar el concurso <strong>{props.name}</strong>?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{boxShadow: "none"}}
                        variant="contained"
                        onClick={handleOpen}
                    >
                        Cancelar
                    </Button>
                    <Button
                        style={{boxShadow: "none"}}
                        color="secondary"
                        variant="contained"
                        onClick={handleClick}
                    >
                        Aprobar
                    </Button>
                </DialogActions>
                <Backdrop className={classes.backdrop} open={openSpinner}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
            </Dialog>
            <Backdrop className={classes.backdrop} open={openSpinner}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Fragment>
    );
};

export default ApproveModal;
